<script>
import SignaturePad from 'signature_pad'
export default {
  props: {
    // We want to identify these pads, esp. in case there are multiple signatures on a page
    signatureFor: {
      type: String,
      required: true
    },
    // Existing signature to display
    sig: {
      type: String,
      required: false
    },
    // Should not adjust these if using paper checks
    widthPx: {
      type: Number,
      required: false,
      default: 540
    },
    heightPx: {
      type: Number,
      required: false,
      default: 200
    }
  },

  data () {
    return {
      pad: null,
      signature: null,
      modified: false,
      accepted: false
    }
  },

  methods: {
    // Used to create a new pad canvas
    defaultCanvas () {
      this.resizeCanvas()
    },
    // Used to resize a canvas. Generally, need to use it when loading a sig from a file.
    resizeCanvas () {
      // const ratio = Math.max(window.devicePixelRatio || 1, 1)
      let canvas = this.$refs.canvas
      canvas.width = this.widthPx
      canvas.height = this.heightPx
      canvas.getContext('2d').scale(1, 1)
      this.pad.clear()
      this.accepted = false
    },
    // When signature canvas changes, need to mark it as incomplete
    onModify () {
      this.modified = true
      this.accepted = false
      this.$emit('onChange', true)
    },
    // Literally used when the "Accept Signature" button is clicked
    acceptSignature () {
      if (this.pad.isEmpty()) {
        this.$emit('onError', 'Please enter a signature')
        return false
      }

      const signature = this.pad.toDataURL()
      if (!signature) {
        return false
      } else {
        this.accepted = true
        this.signature = signature
        this.$emit('onSigned', this.signature)
        return true
      }
    },
    clearSignature () {
      this.resizeCanvas()
      this.pad.clear()
      this.signature = null
      this.accepted = false
      this.modified = false
      this.$emit('onChange', true)
    },
    loadSignature (sig) {
      if (!sig) {
        return false
      }
      this.resizeCanvas()
      this.pad.fromDataURL(sig)
      this.signature = sig
      this.modified = true
      return true
    }
  },

  mounted () {
    this.pad = new SignaturePad(this.$refs.canvas)
    this.pad.name = this.signatureFor
    this.defaultCanvas()

    // Load an existing signature if available
    if (this.sig) {
      this.loadSignature(this.sig)
    } else {
      this.accepted = false
    }
  }
}
</script>

<template>
  <div id="signature-pad">
    <el-row type="flex" class="signature-pad" align="middle" justify="start">
      <div class="signature-pad__body">
        <canvas name="signature" id="signature_pad" ref="canvas"
          v-on:mouseup="onModify"
          @change="onModify"
          @update="onModify"
          @input="onModify"
          :width="widthPx"
          :height="heightPx"
        ></canvas>
      </div>
      <el-row type="flex" class="signature-pad" align="middle" justify="start">
        <el-button type="danger" class="bold" @click="clearSignature" :disabled="!modified">Clear Signature</el-button>
        <el-button type="success" class="bold" @click="acceptSignature" :disabled="accepted">Accept Signature</el-button>
      </el-row>
    </el-row>
  </div>
</template>

<style scoped>
.bold { font-weight: 700; }
.m-right-20 { margin-right: 20px; }

.signature-pad {
  position: relative;
  display: block;
  background-color: #ccc;
}
.signature-pad button {
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
}

.signature-pad__body canvas {
  position: relative;
  margin: 10px 10px 10px;
  background-color: #fefefe;
}
.signature-pad__body canvas:active {
    cursor: pointer;
}
.signature-pad__body canvas:hover {
    cursor: pointer;
}
</style>
